import React from 'react';
import FieldView, {FieldViewProps} from "../../../../render/view";

type Options = {
    fullPath?       : boolean
    showIcon?       : boolean
    colorize?       : boolean
    maxParents?     : number
}

type Props = FieldViewProps & {
    options?    : Options,
    viewType?   : 'property' | null
};


export default function FieldProjectPath_GlistView(props:Props) {

    return (
        <FieldView field        = {props.field}
                   model        = {props.model}
                   options      = {props.configOptions}
                   params       = {{maxParents: props.field.maxParents}}
                   viewType     = "full-path"
                   className    = "small-less-important"
        />
    )
}
